// Badges für neue und verbesserte Funktionen, jedes mit Ablaufdatum. Ohne Ende
// stand Neu an den E-Mail-Vorlagen von April 2024 bis Oktober 2026 da und fiel
// niemandem mehr auf. Faustregel 8 Wochen ab Release in production.
//
// kind new zeigt Neu, improved zeigt Verbessert (components/feature-badge.js).
// until ist der erste Tag ohne Badge, ab 00:00 UTC. Abgelaufene Einträge samt
// ihrer Verwendung beim nächsten Aufräumen löschen.
export const FEATURE_BADGES = {
  // Einstellungen, Talent-Status, in production seit 15.09.2026
  TALENT_STATUS: { kind: 'new', until: '2026-11-10' },
  // Einstellungen und Stelle, Fristende-Platzhalter und Test-Mail, in
  // production seit 28.10.2026
  MAIL_TEMPLATES: { kind: 'improved', until: '2026-12-23' },
  // Stelle, eigene Bearbeitungszeit. Release ausstehend, beim Release auf
  // 8 Wochen danach setzen.
  CAREER_EXPIRES_AFTER_DAYS: { kind: 'new', until: '2027-01-15' }
}

/**
 * @param {string} id Schlüssel aus FEATURE_BADGES
 * @param {Date} [now]
 * @returns {'new'|'improved'|null} Art des Badges, abgelaufen oder unbekannt null
 */
export const getFeatureBadge = (id, now = new Date()) => {
  const badge = FEATURE_BADGES[id]
  if (!badge) return null
  return now.getTime() < Date.parse(badge.until) ? badge.kind : null
}
